import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import type { LandingFeature } from "./landingContent";

interface FeatureCardProps extends LandingFeature {}

export default function FeatureCard({
  icon: Icon,
  title,
  description,
}: FeatureCardProps) {
  return (
    <Card
      variant="outlined"
      sx={(theme) => ({
        p: 3,
        height: "100%",
        borderRadius: 4,
        backdropFilter: "blur(8px)",
        borderColor:
          theme.palette.mode === "dark"
            ? "rgba(92, 141, 186, 0.40)"
            : "rgba(123, 169, 219, 0.30)",
        backgroundColor:
          theme.palette.mode === "dark"
            ? "rgba(13, 25, 36, 0.82)"
            : "rgba(255,255,255,0.76)",
        boxShadow:
          theme.palette.mode === "dark"
            ? "0 16px 34px rgba(4, 10, 16, 0.32)"
            : "0 16px 34px rgba(21, 46, 83, 0.09)",
        transition:
          "transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow:
            theme.palette.mode === "dark"
              ? "0 22px 42px rgba(4, 10, 16, 0.42)"
              : "0 22px 42px rgba(21, 46, 83, 0.14)",
          borderColor:
            theme.palette.mode === "dark"
              ? "rgba(102, 174, 241, 0.42)"
              : "rgba(92, 160, 224, 0.45)",
        },
      })}
    >
      <Box
        sx={{ display: "flex", gap: 1.5, alignItems: "flex-start", mb: 1.5 }}
      >
        <Box
          sx={(theme) => ({
            p: 1.25,
            borderRadius: 2,
            display: "inline-flex",
            backgroundColor:
              theme.palette.mode === "dark"
                ? "rgba(29, 47, 64, 0.78)"
                : "rgba(231,242,255,0.9)",
            color: "primary.main",
            border:
              theme.palette.mode === "dark"
                ? "1px solid rgba(82, 138, 188, 0.5)"
                : "1px solid rgba(120, 169, 224, 0.35)",
            boxShadow:
              theme.palette.mode === "dark"
                ? "inset 0 1px 0 rgba(106,158,211,0.18)"
                : "inset 0 1px 0 rgba(255,255,255,0.62)",
          })}
        >
          <Icon sx={{ fontSize: 22 }} />
        </Box>
        <Typography variant="h6" sx={{ fontSize: 18, lineHeight: 1.35 }}>
          {title}
        </Typography>
      </Box>
      <Typography color="text.secondary" sx={{ lineHeight: 1.65 }}>
        {description}
      </Typography>
    </Card>
  );
}
